import { render, staticRenderFns } from "./StudentPagination.vue?vue&type=template&id=ede392b6"
import script from "./StudentPagination.vue?vue&type=script&lang=js"
export * from "./StudentPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports